import React from 'react';

export type DesignCard = {
  key: string;
  name: string;
  isNone: boolean;
  previewUrl?: string;
  isActive: boolean;
  onSelect: () => void;
};

export default function DesignGrid({ cards }: { cards: DesignCard[] }) {
  return (
    <div className="design-grid">
      {cards.map(card => (
        <div
          key={card.key}
          className={`design-card ${card.isActive ? 'design-card-active' : ''}`}
          role="button"
          tabIndex={0}
          onClick={card.onSelect}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              card.onSelect();
            }
          }}
        >
          {card.isNone ? (
            <div className="design-empty">Aucun</div>
          ) : (
            <div className="design-preview">
              {card.previewUrl ? (
                <img className="design-preview-img" src={card.previewUrl} alt={card.name} />
              ) : (
                <div className="design-preview-loading" aria-label="Chargement">
                  <div className="loading-spinner"></div>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
